import type { Routes } from "@angular/router";
import { MainLayoutComponent } from "../../layout/main-layout/main-layout.component";
import { hasDoneMultipleThings } from "./guards/laboratory.guard";

export default [
	{
		path: "laboratory",
		component: MainLayoutComponent,
		children: [
			{
				path: "",
				loadComponent: () =>
					import("./laboratory.component").then((c) => c.LaboratoryComponent),
			},
		],
		canActivate: [hasDoneMultipleThings],
	},
] satisfies Routes;
